"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/message/style/css");

var _message2 = _interopRequireDefault(require("antd/es/message"));

var _button = _interopRequireDefault(require("antd/lib/button"));

var _collapse = _interopRequireDefault(require("antd/lib/collapse"));

var _radio = _interopRequireDefault(require("antd/lib/radio"));

var _tabs = _interopRequireDefault(require("antd/lib/tabs"));

var _lodash = _interopRequireDefault(require("lodash"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _typesafeActions = require("typesafe-actions");

var _PostList = _interopRequireDefault(require("../../pages/study/forum/PostList"));

var _api = require("../../redux/api/api.types");

var _dashboard = require("../../redux/dashboard/dashboard.types");

var _forum = require("../../redux/forum/forum.types");

var _participants = require("../../redux/participants/participants.types");

var _posts = require("../../redux/posts/posts.types");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

var _SearchInput = _interopRequireDefault(require("../search/SearchInput"));

var _ForumPostCreationModal = _interopRequireDefault(require("./ForumPostCreationModal"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  TabPane
} = _tabs.default;
const {
  Panel
} = _collapse.default;
const initialState = {
  selectedPost: undefined,
  selectedFlaggedPost: undefined,
  isEditing: false,
  editedPost: undefined,
  armFilterId: 0,
  getPostsSearch: _posts.initialGetPostsSearch,
  searchIsCollapsed: false,
  postCreationModalVisible: false,
  newPostTitle: '',
  newPostBody: '',
  newPostPollOptions: [{
    option: ''
  }],
  addPostError: false,
  addPostErrorMessage: '',
  newPostArm2Selected: true,
  newPostArm3Selected: true,
  newPostTopic: 'Select a topic',
  showDeleted: true,
  firstDataLoad: false
};

class ForumPage extends _react.Component {
  constructor() {
    super(...arguments);
    this.state = initialState;

    this.handleSearchStringChange = event => {
      const {
        getPosts,
        resetRecentActivityPostIds
      } = this.props;
      const {
        getPostsSearch
      } = this.state;
      const value = event.target.value.toString();
      resetRecentActivityPostIds();
      this.setState({
        getPostsSearch: Object.assign(getPostsSearch, {
          searchText: value,
          pageNumber: 0
        })
      });

      if (value.length > 0) {
        Object.assign(getPostsSearch, {
          searchText: value
        });
        getPosts(getPostsSearch);
      } else {
        Object.assign(getPostsSearch, {
          searchText: undefined
        });
        getPosts(getPostsSearch);
      }
    };

    this.handleSearchSubmit = value => {
      const {
        getPosts
      } = this.props;
      const {
        getPostsSearch
      } = this.state;
      Object.assign(getPostsSearch, {
        searchText: value
      });
      getPosts(getPostsSearch);
    };

    this.handleSearchCollapseChange = openPanels => {
      const searchIsCollapsed = _lodash.default.isEmpty(openPanels);

      this.setState({
        searchIsCollapsed
      });
    };

    this.handleShowDeletedChange = checked => {
      this.setState({
        showDeleted: checked,
        getPostsSearch: Object.assign(this.state.getPostsSearch, {
          includeDeleted: checked
        })
      }, () => {
        this.props.getPosts(this.state.getPostsSearch);
      });
    };

    this.renderSearchCriteriaSection = () => {
      const {
        forums,
        arms
      } = this.props;

      const armsById = _lodash.default.groupBy(arms, 'id');

      const internalArmFilterChange = event => {
        const studyArmIds = event.target.value === -1 ? forums ? forums.map(f => f.studyArmId) : [] : [event.target.value];
        const newGetPostsSearch = Object.assign(this.state.getPostsSearch, {
          studyArmIds,
          pageNumber: 0
        });
        this.setState({
          getPostsSearch: newGetPostsSearch,
          selectedPost: undefined
        });
        this.props.resetRecentActivityPostIds();
        this.props.updateRecentActivityScroll(0);
        this.props.getPosts(newGetPostsSearch);
      };

      const {
        getPostsSearch,
        showDeleted
      } = this.state;
      const selectedValue = getPostsSearch.studyArmIds.length === 1 ? getPostsSearch.studyArmIds[0] : -1;
      return /*#__PURE__*/_react.default.createElement("div", {
        id: "search-container"
      }, /*#__PURE__*/_react.default.createElement(_collapse.default, {
        defaultActiveKey: ['search'],
        expandIconPosition: "right",
        onChange: this.handleSearchCollapseChange
      }, /*#__PURE__*/_react.default.createElement(Panel, {
        key: "search",
        header: "Search Criteria"
      }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_SearchInput.default, {
        id: "search-input",
        onChangeHandler: this.handleSearchStringChange,
        onSubmitHandler: this.handleSearchSubmit,
        placeholder: "Search Forum",
        value: this.state.getPostsSearch.searchText
      }), forums && forums.length > 1 && /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("br", null), /*#__PURE__*/_react.default.createElement(_radio.default.Group, {
        id: "arm-filter",
        value: selectedValue,
        onChange: internalArmFilterChange
      }, /*#__PURE__*/_react.default.createElement(_radio.default.Button, {
        key: "arm-radio--1",
        value: -1
      }, "All"), forums === null || forums === void 0 ? void 0 : forums.map(f => /*#__PURE__*/_react.default.createElement(_radio.default.Button, {
        key: `arm-radio-${armsById[f.studyArmId][0].id}`,
        value: armsById[f.studyArmId][0].id
      }, armsById[f.studyArmId][0].name))))))));
    };

    this.handleTabChange = activeKey => {
      const {
        history,
        getPosts,
        getUncategorizedPosts,
        getFlaggedPosts,
        studyId
      } = this.props;
      const {
        getPostsSearch
      } = this.state;

      switch (activeKey) {
        case 'recentActivity':
          getPosts(getPostsSearch);
          break;

        case 'uncategorized':
          getUncategorizedPosts();
          break;

        case 'flagged':
          getFlaggedPosts();
          break;
      }

      history.push(`/study/${studyId}/forums/${activeKey}`);
    };

    this.onRecentActivityScroll = (scrollTop, event) => {
      this.props.updateRecentActivityScroll(scrollTop);
      const {
        scrollHeight,
        clientHeight
      } = event.target;

      if (Math.round(scrollHeight - scrollTop) === clientHeight) {
        this.onGetMorePosts();
      }
    };

    this.onGetMorePosts = () => {
      const {
        getPosts
      } = this.props;
      const {
        getPostsSearch
      } = this.state;

      const nextPageSearch = _lodash.default.cloneDeep(getPostsSearch);

      nextPageSearch.pageNumber++;
      this.setState({
        getPostsSearch: nextPageSearch
      });
      getPosts(nextPageSearch);
    };

    this.onFlaggedScroll = (scrollTop, event) => {
      this.props.updateFlaggedScroll(scrollTop);
    };

    this.onUncategorizedScroll = (scrollTop, event) => {
      this.props.updateUncategorizedScroll(scrollTop);
    };

    this.onSelectRecentActivityPost = post => {
      this.props.updateRecentActivitySelectedPostId(post.id);
    };

    this.onSelectFlaggedPost = post => {
      this.props.updateFlaggedSelectedPostId(post.id);
    };

    this.onSelectUncategorizedPost = post => {
      this.props.updateUncategorizedSelectedPostId(post.id);
    };

    this.handleShowAddPostModal = () => {
      this.setState({
        postCreationModalVisible: true,
        addPostError: false
      });
    };

    this.closePostCreationModal = () => {
      this.setState({
        postCreationModalVisible: false
      });
    };
  }

  componentDidMount() {
    this.props.resetRecentActivityPostIds();
  } // normally we would use componentDidMount to make our API calls but in this case we need some props (like forums) which only
  // exist AFTER componentDidMount is called.  The firstDataLoad state prop makes sure initial data only loads once


  static getDerivedStateFromProps(props, state) {
    var _a;

    if (((_a = props.forums) === null || _a === void 0 ? void 0 : _a.length) && !state.firstDataLoad) {
      props.getParticipantsByStudy(props.studyId);
      props.loadDashboardData();
      const studyArmIds = props.forums.map(f => f.studyArmId);
      const getPostsSearch = Object.assign(_posts.initialGetPostsSearch, {
        studyArmIds
      });
      const forumsSubpage = props.forumsSubpage === '' ? 'recentActivity' : props.forumsSubpage;

      switch (forumsSubpage) {
        case 'recentActivity':
          props.getPosts(state.getPostsSearch);
          break;

        case 'uncategorized':
          props.getUncategorizedPosts();
          break;

        case 'flagged':
          props.getFlaggedPosts();
          break;

        default:
          throw `Bad forumSubpage (${forumsSubpage})`;
      }

      return {
        getPostsSearch,
        firstDataLoad: true
      };
    }

    return null;
  }

  componentDidUpdate(prevProps) {
    const {
      saveForumPostStatus
    } = this.props;

    if (!prevProps.saveForumPostStatus.isError && saveForumPostStatus.isError) {
      _message2.default.error(`There was an error saving posts:\n${saveForumPostStatus.errorMessage}`, 3);

      (0, _api.clearStatus)((0, _typesafeActions.getType)(_posts.savePostAsync.failure));
    }

    if (!prevProps.saveForumPostStatus.isSuccess && saveForumPostStatus.isSuccess) {
      _message2.default.success('Forum posts created/updated successfully.');

      (0, _api.clearStatus)((0, _typesafeActions.getType)(_posts.savePostAsync.success));
    }
  }

  render() {
    const {
      getPostsStatus,
      posts = [],
      uncategorizedPosts,
      flaggedPosts,
      dashboardData,
      loadDashboardDataStatus,
      recentActivityScrollTop,
      flaggedPostsScrollTop,
      uncategorizedPostsScrollTop,
      recentActivitySelectedPostId,
      flaggedPostsSelectedPostId,
      uncategorizedPostsSelectedPostId,
      saveForumPostStatus,
      clearStatus,
      forums
    } = this.props;
    const {
      postCreationModalVisible
    } = this.state;
    const forumsSubpage = this.props.forumsSubpage === '' ? 'recentActivity' : this.props.forumsSubpage;

    if (getPostsStatus.isError || loadDashboardDataStatus.isError) {
      return /*#__PURE__*/_react.default.createElement("div", null, `Error: ${getPostsStatus.isError ? getPostsStatus.errorMessage : loadDashboardDataStatus.isError ? loadDashboardDataStatus.errorMessage : ' some kind of error'}`);
    }

    const addPost = /*#__PURE__*/_react.default.createElement(_button.default, {
      type: "primary",
      onClick: this.handleShowAddPostModal
    }, "+ Add Post");

    const expandedeHeight = 375;
    const listHeight = window.innerHeight - (this.state.searchIsCollapsed ? expandedeHeight - 118 : expandedeHeight);
    return /*#__PURE__*/_react.default.createElement("div", {
      id: "hmp-forum-page"
    }, /*#__PURE__*/_react.default.createElement(_ForumPostCreationModal.default, {
      visible: postCreationModalVisible,
      closeHandler: this.closePostCreationModal
    }), /*#__PURE__*/_react.default.createElement(_tabs.default, {
      defaultActiveKey: forumsSubpage,
      tabBarExtraContent: addPost,
      onChange: this.handleTabChange
    }, /*#__PURE__*/_react.default.createElement(TabPane, {
      key: "recentActivity",
      tab: "Forum Posts"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-forum-page-tab"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-forum-page-tab-search"
    }, this.renderSearchCriteriaSection()), /*#__PURE__*/_react.default.createElement(_PostList.default, {
      height: listHeight,
      onScroll: this.onRecentActivityScroll,
      scrollTop: recentActivityScrollTop,
      selectedPostId: recentActivitySelectedPostId,
      onSelectPost: this.onSelectRecentActivityPost,
      posts: posts
    }), /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: 'lightblue',
        textDecoration: 'underline',
        marginTop: 5,
        cursor: 'pointer'
      },
      onClick: this.onGetMorePosts
    }, "Get More Posts"))), /*#__PURE__*/_react.default.createElement(TabPane, {
      key: "flagged",
      tab: `${dashboardData && dashboardData.forum.flagged} Flagged`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-forum-page-tab"
    }, /*#__PURE__*/_react.default.createElement(_PostList.default, {
      height: listHeight,
      onScroll: this.onFlaggedScroll,
      scrollTop: flaggedPostsScrollTop,
      selectedPostId: flaggedPostsSelectedPostId,
      onSelectPost: this.onSelectFlaggedPost,
      posts: flaggedPosts
    }))), /*#__PURE__*/_react.default.createElement(TabPane, {
      key: "uncategorized",
      tab: `${dashboardData && dashboardData.forum.uncategorized} Uncategorized`
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "hmp-forum-page-tab"
    }, /*#__PURE__*/_react.default.createElement(_PostList.default, {
      height: listHeight,
      scrollTop: uncategorizedPostsScrollTop,
      onScroll: this.onUncategorizedScroll,
      selectedPostId: uncategorizedPostsSelectedPostId,
      onSelectPost: this.onSelectUncategorizedPost,
      posts: uncategorizedPosts
    })))));
  }

}

const mapStateToProps = state => {
  const study = selectors.getRequestedStudy(state);
  const posts = selectors.getLastSearchResultPosts(state);
  const uncategorizedPosts = selectors.getUncategorizedPosts(state);
  const flaggedPosts = selectors.getFlaggedPosts(state);
  const flags = selectors.getFlags(state);
  const comments = selectors.getComments(state);
  const thumbsups = selectors.getThumbsups(state);
  const favorites = selectors.getFavorites(state);
  const getPostsStatus = selectors.loadPostsStatus(state);
  const dashboardData = selectors.getDashboardData(state);
  const loadDashboardDataStatus = selectors.loadDashboardStatus(state);
  const forumsSubpage = selectors.getRequestedForumsTab(state);
  const recentActivityScrollTop = state.ui.forums.recentActivity.scrollTop;
  const flaggedPostsScrollTop = state.ui.forums.flaggedPosts.scrollTop;
  const uncategorizedPostsScrollTop = state.ui.forums.uncategorizedPosts.scrollTop;
  const recentActivitySelectedPostId = state.ui.forums.recentActivity.selectedPostId;
  const flaggedPostsSelectedPostId = state.ui.forums.flaggedPosts.selectedPostId;
  const uncategorizedPostsSelectedPostId = state.ui.forums.uncategorizedPosts.selectedPostId;
  const pseudoParticipants = selectors.getCurrentUserPseudoParticipants(state);
  const topics = selectors.getForumTopics(state);
  const arms = selectors.getRequestedStudyStudyArms(state);
  const studyId = selectors.getRequestedStudyId(state);
  const saveForumPostStatus = selectors.saveForumPostStatus(state);
  const forums = selectors.getForums(state);
  return {
    study,
    getPostsStatus,
    posts,
    flags,
    comments,
    uncategorizedPosts,
    thumbsups,
    favorites,
    dashboardData,
    loadDashboardDataStatus,
    flaggedPosts,
    forumsSubpage,
    recentActivityScrollTop,
    flaggedPostsScrollTop,
    uncategorizedPostsScrollTop,
    recentActivitySelectedPostId,
    flaggedPostsSelectedPostId,
    uncategorizedPostsSelectedPostId,
    pseudoParticipants,
    topics,
    arms,
    studyId,
    saveForumPostStatus,
    forums
  };
};

const mapDispatchToProps = dispatch => {
  return {
    savePost: newPost => dispatch(_posts.savePostAsync.request(newPost)),
    getPosts: postsSearch => dispatch(_posts.getPostsAsync.request(postsSearch)),
    getUncategorizedPosts: () => dispatch(_posts.getUncategorizedPostsAsync.request()),
    getFlaggedPosts: () => dispatch(_posts.getFlaggedPostsAsync.request()),
    loadDashboardData: () => dispatch(_dashboard.loadDashboardDataAsync.request()),
    updateRecentActivityScroll: scrollTop => dispatch((0, _forum.updateRecentActivityScroll)(scrollTop)),
    updateFlaggedScroll: scrollTop => dispatch((0, _forum.updateFlaggedScroll)(scrollTop)),
    updateUncategorizedScroll: scrollTop => dispatch((0, _forum.updateUncategorizedScroll)(scrollTop)),
    updateRecentActivitySelectedPostId: selectedPostId => dispatch((0, _forum.updateRecentActivitySelectedPostId)(selectedPostId)),
    updateFlaggedSelectedPostId: selectedPostId => dispatch((0, _forum.updateFlaggedSelectedPostId)(selectedPostId)),
    updateUncategorizedSelectedPostId: selectedPostId => dispatch((0, _forum.updateUncategorizedSelectedPostId)(selectedPostId)),
    resetRecentActivityPostIds: () => dispatch((0, _forum.resetRecentActivityPostIds)()),
    clearStatus: type => dispatch((0, _api.clearStatus)(type)),
    getParticipantsByStudy: studyId => dispatch(_participants.getParticipantsByStudyAsync.request(studyId))
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ForumPage);

exports.default = _default;